export const SET_EMAIL = 'submissionEmailValidationComponent.setEmail'
export const SET_IS_VALID_EMAIL = 'submissionEmailValidationComponent.setIsValidEmail'
export const SET_IS_SUBMITTING = 'submissionEmailValidationComponent.setSubmitting'
export const SET_ERROR = 'submissionEmailValidationComponent.setError'
export const RESET = 'submissionEmailValidationComponent.reset'

export function setEmail(payload: string) {
  return {
    type: SET_EMAIL,
    payload
  } as const
}

export function setIsValidEmail(payload: boolean) {
  return {
    type: SET_IS_VALID_EMAIL,
    payload
  } as const
}

export function setIsSubmitting(payload: boolean) {
  return {
    type: SET_IS_SUBMITTING,
    payload
  } as const
}

export function setError(payload: string) {
  return {
    type: SET_ERROR,
    payload
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type SubmissionEmailValidationAction = ReturnType<
  typeof setEmail | typeof setIsValidEmail | typeof setIsSubmitting | typeof setError | typeof reset
>
